import {
    FETCH_DRIVER,
    FETCH_DRIVERS,
    FETCH_DRIVER_COUNT,
    FETCH_DRIVER_PROPERTIES,
    FETCH_DRIVER_DEFAULTS,
    FETCH_DRIVER_OPMODES,
    FETCH_DRIVER_OPMODES_SELECTED,
    FETCH_DRIVER_FEATURES,
    FETCH_DRIVER_PERMISSIONS,
    FETCH_DRIVER_PROGRAMMING_SELECTION,
    UPDATE_DRIVER_PROGRAMMING_SELECTION,
    UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION,
    UPDATE_DRIVER_COUNT,
    RESET,
    RESET_DRIVER,
    UPDATE_DRIVER,
    FETCH_LOCKED_FEATURES,
    FETCH_ASTRO_SAVINGS
} from '../actions/types';

import {
    TOUCH_DIM_AND_SENSOR
} from '../utils/constantFeatures';

const INITIAL_STATE = {
    info: null,
    properties: null,
    // Factory defaults from the DD store, keyed by property name. Kept separate from each property's
    // own valueMeta.default, which on an imported project holds the device readback instead.
    factoryDefaults: null,
    opmodes: null,
    opmodesSelected: null,
    features: null,
    programmingSelection: null,
    permissions: null,
    count: null,
    lockedFeatures:[],
    astroSavingsValue: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_DRIVERS:
            return Object.assign({}, state, {
                info: action.payload[0],
            });

        case FETCH_DRIVER:
            return Object.assign({}, state, {
                info: action.payload,
            });

        case FETCH_DRIVER_COUNT:
            return Object.assign({}, state, {
                count: action.payload,
            });

        case FETCH_DRIVER_PROPERTIES:
            return Object.assign({}, state, {
                properties: action.payload,
            });

        case FETCH_DRIVER_DEFAULTS:
            return Object.assign({}, state, {
                factoryDefaults: action.payload,
            });

        case FETCH_ASTRO_SAVINGS:
            return Object.assign({}, state, {
                astroSavingsValue: action.payload,
            });

        case FETCH_DRIVER_OPMODES:
            return Object.assign({}, state, {
                opmodes: action.payload,
            });

        case FETCH_DRIVER_OPMODES_SELECTED:
            return Object.assign({}, state, {
                opmodesSelected: Object.assign({}, state.opmodesSelected, action.payload),
            });

        case FETCH_DRIVER_FEATURES:

            const touchDimIndex = action.payload.map(f => { return f.name; }).indexOf(TOUCH_DIM_AND_SENSOR.shortName);

            if (touchDimIndex > -1) {
                const corridor = {
                    id: 0,
                    displayName: "Corridor",
                    name: "td_c",
                    instanceCount: action.payload[touchDimIndex].instanceCount
                };
                action.payload.splice(touchDimIndex + 1, 0, corridor);
            }

            return Object.assign({}, state, {
                features: action.payload,
            });

        case FETCH_DRIVER_PERMISSIONS:
            return Object.assign({}, state, {
                permissions: action.payload,
            });

        case FETCH_LOCKED_FEATURES:
            return Object.assign({}, state, {
                lockedFeatures: action.payload != null ? action.payload.split(';') : [],
            });

        case FETCH_DRIVER_PROGRAMMING_SELECTION:
            return Object.assign({}, state, {
                programmingSelection: [...(action.payload != null ? action.payload.split(',') : [])],
            });

        case UPDATE_DRIVER_COUNT:
            return Object.assign({}, state, {
                count: action.payload,
            });

        case UPDATE_DRIVER_PROGRAMMING_SELECTION:
        case UPDATE_DRIVER_PROGRAMMING_SINGLE_SELECTION:
            return Object.assign({}, state, {
                programmingSelection: [...(action.payload != null && action.payload.programmingSelections ? action.payload.programmingSelections.split(',') : [])],
            });

        case UPDATE_DRIVER:
            return Object.assign({}, state, {
                info: action.payload,
            });

        case RESET:
        case RESET_DRIVER:
            return INITIAL_STATE;

        default:
            return state;
    }
};
